import React, {Component} from 'react';
import LoginThirdBtn from "../LoginThirdBtn";
import DingdingCode from "../DingdingCode";
import './index.css'

class DingdingCodeLogin extends Component {
    render() {
        const {changeContModePage, customLoginConfig} = this.props;
        const modeBtnShow={
            dingdingShow:false,
            workWechatShow:true,
            feishuShow:true,
            qyWechatShow:true,
            qyzjWechatShow:true,
            wechatShow:true,
            ssoShow: true,
            LoginAccountPasswordShow: true,
            LoginCodeShow: true,
        }
        return (
            <div className="DingdingCodeLogin">
                <div className="loginContentBox">
                    <div className="title">
                        {React.language('account.signin.dingtalk')}
                    </div>
                    <DingdingCode APPID={window.data_config.dingding_appid} params={window.location.href} />
                </div>
                <LoginThirdBtn modeBtnShow={modeBtnShow} customLoginConfig={customLoginConfig} changeContModePage={changeContModePage} />
            </div>
        );
    }
}

export default DingdingCodeLogin;